import React from 'react';
import { Col } from 'antd';
import { LineFormItem } from '@/components/views/Resolution886/components/Form';

export function Line(): JSX.Element {
	return (
		<Col xs={24}>
			<LineFormItem fieldName="line_id" required={false} />
		</Col>
	);
}
